export default function (parent, node, position) {
    if (position < parent.childNodes.length) {
        parent.insertBefore(node, parent.childNodes[position]);
    } else {
        parent.appendChild(node);
    }
}